module.exports = __webpack_public_path__ + "static/fonts/a82a5fb6-ad03-4675-801e-d3182a58ff5f.623b22d.ttf";